<template>
  <div>
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="row container-form details-area">
        <b-form novalidate class="col-xs-12">
          <div class="header-form py-2">
            <div class="d-flex justify-content-center">
              <bell-icon class="mr-1" title="" />
              <div class="px-2">
                <span v-if="isEditing"> Editando alerta do sensor: </span>
                <span v-else>Adicionar alerta</span>
                <br />
                {{ oldName }}
              </div>
            </div>
          </div>
          <div class="sensors-general pl-3 pr-3">
            <div v-if="!isEditing">
              <b-form-text id="title-sensor_id">Nome do sensor:</b-form-text>
              <div>
                <searchable-select
                  v-model="form.SENSOR_ID"
                  :options="sensorsOptions"
                  :state="sensor_id_state"
                  :clearable="false"
                  placeholder="Selecione um sensor"
                />
              </div>
              <div v-if="isEditing">
                <b-form-input v-model="form.SENSOR_NAME" :readonly="true" />
              </div>
              <hr />
            </div>
            <b-form-text class="header-form border-0 mt-3"
              ><strong>Parâmetros:</strong></b-form-text
            >
            <br />
            <div class="mb-3">
              <b-form-text id="title-tolerance_low">
                Tempo tolerado <strong>abaixo</strong> dos parâmetros ( min ):
              </b-form-text>
              <!-- <b-form-text v-show="form.FK_MODEL">Modelo *</b-form-text> -->
              <b-form-input
                v-model="form.TOLERANCE_LOW"
                placeholder="Exemplo: 1"
                :formatter="notEmpty"
                maxlength="24"
                size="sm"
                id="input-tolerance_low"
                aria-describedby="tolerance_lowInput tolerance_lowInputLiveFeedback"
                :state="tolerance_low_state"
              />
              <b-form-invalid-feedback
                v-if="!tolerance_low_state"
                id="tolerance_lowInputLiveFeedback"
              >
                Obrigatório. (Tempo mínimo é de 1 minuto)
              </b-form-invalid-feedback>
            </div>

            <div class="mb-3">
              <b-form-text
                >Tempo de re-envio do alerta <strong>abaixo</strong> ( min
                ):</b-form-text
              >
              <b-form-input
                v-model="form.TIME_TO_RESEND_LOW"
                placeholder="Exemplo: 30"
                :formatter="notEmpty"
                maxlength="24"
                size="sm"
                id="input-time_to_resend_low"
                aria-describedby="time_to_resend_lowInput time_to_resend_lowInputLiveFeedback"
                :state="time_to_resend_state_low"
              />
              <b-form-invalid-feedback
                v-if="!time_to_resend_state_low"
                id="time_to_resend_lowInputLiveFeedback"
              >
                Obrigatório. (Tempo mínimo é de 30 minutos)
              </b-form-invalid-feedback>
            </div>

            <div class="mb-3">
              <b-form-text id="title-tolerance_high">
                Tempo tolerado <strong>acima</strong> dos parâmetros ( min ):
              </b-form-text>
              <b-form-input
                v-model="form.TOLERANCE_HIGH"
                placeholder="Exemplo: 1"
                :formatter="notEmpty"
                maxlength="24"
                size="sm"
                id="input-tolerance_high"
                aria-describedby="tolerance_highInput tolerance_highInputLiveFeedback"
                :state="tolerance_high_state"
              />
              <b-form-invalid-feedback
                v-if="!tolerance_high_state"
                id="tolerance_highInputLiveFeedback"
              >
                Obrigatório. (Tempo mínimo é de 1 minuto)
              </b-form-invalid-feedback>
            </div>
          </div>

          <div class="pl-3 pr-3">
            <div class="mb-3">
              <b-form-text
                >Tempo de re-envio do alerta <strong>acima</strong> ( min
                ):</b-form-text
              >
              <b-form-input
                v-model="form.TIME_TO_RESEND_HIGH"
                placeholder="Exemplo: 30"
                :formatter="notEmpty"
                maxlength="24"
                size="sm"
                id="input-time_to_resend_high"
                aria-describedby="time_to_resend_highInput time_to_resend_highInputLiveFeedback"
                :state="time_to_resend_state_high"
              />
              <b-form-invalid-feedback
                v-if="!time_to_resend_state_high"
                id="time_to_resend_highInputLiveFeedback"
              >
                Obrigatório. (Tempo mínimo é de 30 minutos)
              </b-form-invalid-feedback>
            </div>
          </div>
          <hr />
          <div class="pl-3 pr-3"></div>

          <div v-if="form.SENSOR_ID" class="sensors-general pl-3 pr-3">
            <b-form-text class="header-form border-0 mt-3"
              ><strong>Medições:</strong></b-form-text
            >
            <br />

            <div
              v-for="(r, index) in currentSensorRanges"
              :key="index"
              class="sensors-measures"
            >
              <b-form-text
                class="header-form border-0 text-left d-flex align-items-center justify-content-between"
              >
                <strong> {{ capitalizeStr(r.TYPE_NAME) }}: </strong>

                <b-form-checkbox
                  v-model="r.IS_RANGE_ACTIVE"
                  size="sm"
                  switch
                  class="my-3"
                />
              </b-form-text>

              <div class="mb-3">
                <b-form-text class="title-email_alert"
                  >Medição <strong>mínima</strong> permitida (
                  {{ r.UNIT }} ):</b-form-text
                >
                <b-form-input
                  :disabled="!r.IS_RANGE_ACTIVE"
                  v-model="r.MIN"
                  placeholder="Mínimo *"
                  size="sm"
                  variant="3v3"
                  maxlength="20"
                />
              </div>

              <div class="mb-3">
                <b-form-text class="title-email_alert"
                  >Medição <strong>máxima</strong> permitida (
                  {{ r.UNIT }} ):</b-form-text
                >
                <b-form-input
                  :disabled="!r.IS_RANGE_ACTIVE"
                  v-model="r.MAX"
                  placeholder="Máximo *"
                  maxlength="20"
                  size="sm"
                />
              </div>
            </div>
          </div>
        </b-form>
      </div>

      <b-modal
        ref="formError"
        no-close-on-backdrop
        centered
        hide-footer
        body-bg-variant="light"
        title="Atenção!"
      >
        <div class="modal-form row pb-3">
          <div class="col-xs-12 center-xs">
            <alert-icon title="" style="font-size: 3em; color: #ffc107" />
          </div>
          <div class="col-xs-12 error-title">
            Por favor,confira o formulário
          </div>
          <div class="col-xs-12 error-description">
            <ul>
              <li v-for="err in errors" :key="err">{{ err }}</li>
            </ul>
          </div>
        </div>
        <b-btn
          v-if="$refs.formError"
          block
          variant="secondary"
          size="sm"
          @click="formCorrect"
          >Irei corrigir</b-btn
        >
      </b-modal>

      <footer id="footer" class="pb-2 d-flex">
        <b-btn
          size="sm"
          variant="outline-secondary"
          @click="closeForm"
          class="mr-1 ml-2 w-100"
        >
          Fechar
        </b-btn>

        <b-btn
          block
          variant="3v3"
          @click="checkForm"
          size="sm"
          class="ml-1 mr-2 w-100"
        >
          Salvar
        </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  notEmpty,
  notRepeatedName,
} from "@/pages/components/regist/form-functions";

import { user } from "@/pages/components/globalstore";

import { alerts, monit } from "@/api";
import Update from "vue-material-design-icons/Update.vue";
import SearchableSelect from "@/pages/components/shared/SearchableSelect.vue";

const { getSensorsRanges } = alerts;

export default {
  name: "AlertForm",
  components: {
    SearchableSelect,
  },
  props: {
    formType: String,
    itemToEdit: [Number, Object],
    sensors: Array,

    monitSensors: Array,
    items: Array,
  },
  data() {
    return {
      alerts: [],
      alertSensorList: [],
      sensorsMonit: [],
      errors: [],
      controller: null,
      currentSensorRanges: [],
      startedSensorRanges: [],
      form: {
        SENSOR_ID: null,
        SENSOR_NAME: null,
        TOLERANCE_LOW: null,
        TOLERANCE_HIGH: null,
        TIME_TO_RESEND_LOW: null,
        TIME_TO_RESEND_HIGH: null,
        EMAIL_ALERT: [],
        RANGES: [],
      },
      updateParams: [],
      updateRanges: [],
      objEmail: [],
      emailAdd: "",
      arrayEmailsAdd: [],
      emailFormCopy: [],
      rangesUpdated: [],
      counter: 0,
      MIN: null,
      MAX: null,
    };
  },
  async created() {
    try {
      this.controller = new AbortController();
      this.getAlertSensors();
      this.sensorsMonit = await (await monit.sensor(this.controller)).json();

      if (this.formType == "add") {
        this.resetForm();
      } else {
        this.form.ID = this.itemToEdit.ID; //IMPORTANTE PARA DIFERENCIAR EDIÇÃO DE ADIÇÃO
        this.form.SENSOR_ID = this.itemToEdit.SENSOR_ID;
        this.form.SENSOR_NAME = this.itemToEdit.NAME;
        this.form.TOLERANCE_LOW = this.itemToEdit.TOLERANCE_LOW;
        this.form.TOLERANCE_HIGH = this.itemToEdit.TOLERANCE_HIGH;
        this.form.TIME_TO_RESEND_LOW = this.itemToEdit.TIME_TO_RESEND_LOW;
        this.form.TIME_TO_RESEND_HIGH = this.itemToEdit.TIME_TO_RESEND_HIGH;
        this.form.EMAIL_ALERT = this.itemToEdit.EMAIL_ALERT;
        this.emailFormCopy = [...this.form.EMAIL_ALERT];
      }
    } catch (e) {
      console.error(e);
    }
  },
  watch: {
    async "form.SENSOR_ID"(newValue) {
      try {
        if (newValue) {
          const { data: sensorRange } = await this.getSensorRange(newValue);

          this.currentSensorRanges = sensorRange.map((sensor) => {
            sensor.IS_RANGE_ACTIVE = !!sensor.IS_RANGE_ACTIVE;

            if (!this.isEditing) {
              sensor.IS_RANGE_ACTIVE = true;
            }

            return sensor;
          });
        }

        this.startedSensorRanges = JSON.parse(
          JSON.stringify(this.currentSensorRanges)
        );
      } catch (e) {
        console.error(e);
      }
    },
  },
  computed: {
    usedNames() {
      return this.alertSensorList.map((s) => s.NAME);
    },
    oldName() {
      return this.itemToEdit && this.itemToEdit.NAME;
    },
    sensorsOptions() {
      //  Example: [{ "value": 20, "text": "CX01_FLUXO" }]
      let options = this.sensorsMonit
        .filter((sensor) => sensor.FOLDER == "sns")
        .map((sensor) => {
          return {
            value: sensor.ID,
            text: sensor.NAME,
          };
        });
      if (this.usedNames) {
        return options.filter((s) => !this.usedNames.includes(s.text));
      }
      return options;
    },
    isEditing() {
      return this.formType == "edit";
    },
    sensor_id_state() {
      return !!this.form.SENSOR_ID;
    },
    email_alert_state() {
      if (!this.isEditing) {
        const emailRegex = new RegExp(
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        );
        return (
          this.form.EMAIL_ALERT !== null &&
          this.form.EMAIL_ALERT !== "" &&
          emailRegex.test(this.form.EMAIL_ALERT)
        );
      } else {
        return true;
      }
    },
    emailAddstate() {
      const emailRegex = new RegExp(
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
      );
      return (
        this.emailAdd !== null &&
        this.emailAdd !== "" &&
        emailRegex.test(this.emailAdd)
      );
    },
    tolerance_low_state() {
      return !!this.form.TOLERANCE_LOW && this.form.TOLERANCE_LOW >= 1;
    },
    tolerance_high_state() {
      return !!this.form.TOLERANCE_HIGH && this.form.TOLERANCE_HIGH >= 1;
    },
    tolerance_state() {
      return !!(this.tolerance_high_state && this.tolerance_low_state);
    },
    time_to_resend_state_low() {
      return (
        !!this.form.TIME_TO_RESEND_LOW && this.form.TIME_TO_RESEND_LOW >= 30
      );
    },
    time_to_resend_state_high() {
      return (
        !!this.form.TIME_TO_RESEND_HIGH && this.form.TIME_TO_RESEND_HIGH >= 30
      );
    },
    time_to_resend_state() {
      return !!(
        this.time_to_resend_state_low && this.time_to_resend_state_high
      );
    },
    notRepeatedName() {
      return notRepeatedName(this.form.NAME, this.formType, this.oldName);
    },
  },
  methods: {
    async getAlertSensors() {
      try {
        let response = await alerts.getAllSensors(user.ID);
        this.alerts = response.data && response.data;
        this.alertSensorList = this.alerts.map((e) => e);
      } catch (err) {
        console.log(err);
      }
    },
    async submit(data) {
      const actionAlert = this.formType == "add" ? "salvar" : "atualizar";

      try {
        let ret;
        if (this.formType == "add") {
          const sensorExists = this.items.find((item) => {
            return item.SENSOR_ID == data.SENSOR_ID;
          });

          if (!sensorExists) {
            ret = await alerts.addSensor(user.ID, {
              SENSOR_ID: data.SENSOR_ID,
              TOLERANCE_LOW: data.TOLERANCE_LOW,
              TOLERANCE_HIGH: data.TOLERANCE_HIGH,
              TIME_TO_RESEND_LOW: data.TIME_TO_RESEND_LOW,
              TIME_TO_RESEND_HIGH: data.TIME_TO_RESEND_HIGH,
              EMAIL_ALERT: [data.EMAIL_ALERT],
              RANGES: data.RANGES,
              USER_ID: user.ID,
            });
          }
        } else {
          // const copyData = { ...data };

          // delete copyData.ACTIVE_ALERTS;

          ret = await alerts.updateSensor(user.ID, {
            data,
          });

          data = [];
        }
        if (ret.flag != "failed") {
          alert(`Sucesso ao ${actionAlert} alerta`, "s");
        }
      } catch (e) {
        alert(`Ocorreu um erro ao ${actionAlert} alerta`, "e");
        console.error(e);
      }
    },
    async submitRanges(updateRanges) {
      try {
        let response = await alerts.updateSensorRanges(user.ID, {
          data: updateRanges,
        });
        updateRanges.length = 0;

        alert("Parâmetros de medições atualizados com sucesso", "s");
      } catch (e) {
        alert("Erro ao atualizar parâmetros de medições", "e");
      }
    },
    async getSensorRange(sensorId) {
      try {
        const response = await getSensorsRanges(sensorId);

        return response;
      } catch (e) {
        console.error(e);
        alert(
          "Erro ao buscar dados de mínimo e máximo de medidas do sensor",
          "e"
        );

        return [];
      }
    },
    capitalizeStr(stringToCapitalize) {
      if (!stringToCapitalize) return;

      const loweredString = stringToCapitalize.toLowerCase();

      return loweredString.charAt(0).toUpperCase() + loweredString.slice(1);
    },
    closeForm() {
      this.resetForm();
      this.$emit("close-form");
      this.currentSensorRanges = [];
      this.MIN = null;
      this.MAX = null;
    },
    toDeleteEmail(param) {
      let index = this.emailFormCopy.indexOf(param);
      this.emailFormCopy.splice(index, 1);
      let alert = this.alerts.find(
        (item) => item.SENSOR_ID == this.form.SENSOR_ID
      );
      this.updateParams.push({
        column: "EMAIL",
        value: {
          modify: "DELETE",
          email: param,
        },
        id_alert: alert.ID_ALERT,
      });
    },
    toAddEmail() {
      this.arrayEmailsAdd.push(this.emailAdd);
      this.emailAdd = "";
    },
    deleteFromEmailArray(email) {
      let index = this.arrayEmailsAdd.indexOf(email);
      this.arrayEmailsAdd.splice(index, 1);
    },
    notEmpty(value) {
      return notEmpty(value);
    },
    resetForm() {
      this.firstFKModelChange = false;
      this.range = [];
      this.form = {
        SENSOR_ID: null,
        TOLERANCE_LOW: null,
        TOLERANCE_HIGH: null,
        TIME_TO_RESEND_LOW: null,
        TIME_TO_RESEND_HIGH: null,
        EMAIL_ALERT: null,
      };
      this.minMaxState = true;
    },
    formCorrect() {
      this.$refs.formError.hide();
      this.errors.length = 0;
    },
    async checkForm() {
      this.errors = [];
      let states = [
        this.sensor_id_state,
        this.tolerance_state,
        this.time_to_resend_state,
      ];
      let errors = [
        "Nome inválido.",
        "Tempo de tolerância inválido.",
        "Tempo de re-envio inválido.",
      ];

      states.map((state, index) => {
        if (state === false) {
          this.errors.push(errors[index]);
        }
      });

      if (this.formType === "edit") {
        const columnsRanges = Object.keys(this.currentSensorRanges[0]);

        for (let i = 0; i < this.currentSensorRanges.length; i++) {
          for (let j = 0; j < columnsRanges.length; j++) {
            const key = columnsRanges[j];

            let currentItemNewvalue = this.currentSensorRanges[i][key];
            let currentItemOldvalue = this.startedSensorRanges[i][key];

            if (typeof currentItemNewvalue == "boolean") {
              currentItemNewvalue = currentItemNewvalue ? 1 : 0;
              currentItemOldvalue = currentItemOldvalue ? 1 : 0;
            }

            if (currentItemNewvalue != currentItemOldvalue) {
              this.updateRanges.push({
                ID_ALERT: this.itemToEdit.ID_ALERT,
                COLUMN: key,
                VALUE: currentItemNewvalue,
                POS: this.currentSensorRanges[i].POS,
              });
            }
          }
        }

        if (this.form.TOLERANCE_LOW != this.itemToEdit.TOLERANCE_LOW) {
          this.updateParams.push({
            column: "TOLERANCE_LOW",
            value: this.form.TOLERANCE_LOW,
            id_alert: this.itemToEdit.ID_ALERT,
          });
        }
        if (this.form.TOLERANCE_HIGH != this.itemToEdit.TOLERANCE_HIGH) {
          this.updateParams.push({
            column: "TOLERANCE_HIGH",
            value: this.form.TOLERANCE_HIGH,
            id_alert: this.itemToEdit.ID_ALERT,
          });
        }
        if (
          this.form.TIME_TO_RESEND_LOW != this.itemToEdit.TIME_TO_RESEND_LOW
        ) {
          this.updateParams.push({
            column: "TIME_TO_RESEND_LOW ",
            value: this.form.TIME_TO_RESEND_LOW,
            id_alert: this.itemToEdit.ID_ALERT,
          });
        }
        if (
          this.form.TIME_TO_RESEND_HIGH != this.itemToEdit.TIME_TO_RESEND_HIGH
        ) {
          this.updateParams.push({
            column: "TIME_TO_RESEND_HIGH",
            value: this.form.TIME_TO_RESEND_HIGH,
            id_alert: this.itemToEdit.ID_ALERT,
          });
        }
        if (this.form.EMAIL_ALERT != this.itemToEdit.EMAIL_ALERT) {
          this.updateParams.push({
            column: "FK_EMAIL_ALERT",
            value: this.form.EMAIL_ALERT,
            id_alert: this.itemToEdit.ID_ALERT,
          });
        }
        if (this.arrayEmailsAdd.length > 0) {
          this.arrayEmailsAdd.map((itemEmail) => {
            let alert = this.alerts.find(
              (item) => item.SENSOR_ID == this.form.SENSOR_ID
            );
            this.updateParams.push({
              column: "EMAIL",
              value: {
                modify: "ADD",
                email: `${itemEmail}`,
              },
              id_alert: `${alert.ID_ALERT}`,
            });
          });
          this.arrayEmailsAdd.length = 0;
        }
        if (this.errors.length) {
          this.$refs.formError.show();
        } else {
          if (this.updateRanges.length > 0) {
            await this.submitRanges(this.updateRanges);
          }
          if (this.updateParams.length > 0) {
            await this.submit(this.updateParams);
          }
          this.resetForm();

          this.$emit("get-data-again");
          this.$emit("close-form");
          return;
        }
      }
      if (this.errors.length) {
        this.$refs.formError.show();
      } else {
        await this.submit({
          ...this.form,
          RANGES: this.currentSensorRanges,
        });

        this.$emit("get-data-again");
        this.$emit("close-form");
      }
      errors = [];
    },
  },
};
</script>

<style scoped>
.error {
  color: #dc3545;
}
.sensors-measures > div {
  font-size: 0.8em;
}
#form {
  padding-left: 0;
  padding-right: 0;
}
@media screen and (max-width: 768px) {
  .container-form {
    padding-bottom: 3em;
    padding-left: 0.5em;
    padding-right: 0em;
    margin-right: 0;
  }
}

.title-email_alert {
  font-size: 13px !important;
}
</style>
